const mutations = {
  'SET_USER' (state, { user }) {
    localStorage.clear()
    if (user) {
      state.user = user.user
    } else {
      state.user = null
    }
    localStorage.setItem('user', JSON.stringify(user))
  },
  'SET_GOOGLE_OAUTH_URL' (state, { googleOAuthUrl }) {
    state.googleOAuthUrl = googleOAuthUrl
  },
}

export default mutations
